module.exports = __webpack_public_path__ + "static/media/MLI.31b2e221.svg";